export interface DailyTSS {
  date: string; // YYYY-MM-DD
  tss: number;
}

export interface PMCDatapoint {
  date: string;
  tss: number;
  ctl: number; // Chronic Training Load (Fitness)
  atl: number; // Acute Training Load (Fatigue)
  tsb: number; // Training Stress Balance (Form)
}

/**
 * Calculates PMC metrics (CTL, ATL, TSB) for a sequence of days.
 * @param dailyTss Array of daily TSS values. Must be contiguous and sorted chronologically.
 * @param startingCtl Initial CTL (default 0)
 * @param startingAtl Initial ATL (default 0)
 * @returns Array of PMC datapoints
 */
export function calculatePMC(
  dailyTss: DailyTSS[],
  startingCtl: number = 0,
  startingAtl: number = 0
): PMCDatapoint[] {
  
  const CTL_CONSTANT = 42;
  const ATL_CONSTANT = 7;
  
  // Calculate the exponential decay factors
  const ctlDecay = Math.exp(-1 / CTL_CONSTANT);
  const atlDecay = Math.exp(-1 / ATL_CONSTANT);

  let currentCtl = startingCtl;
  let currentAtl = startingAtl;

  const pmcData: PMCDatapoint[] = [];

  for (const day of dailyTss) {
    const tssToday = day.tss;

    // Yesterday's values determine today's TSB
    const tsbToday = currentCtl - currentAtl;

    // Apply the EWMA formula for today's CTL and ATL
    currentCtl = currentCtl + (tssToday - currentCtl) * (1 - ctlDecay);
    currentAtl = currentAtl + (tssToday - currentAtl) * (1 - atlDecay);

    pmcData.push({
      date: day.date,
      tss: tssToday,
      ctl: Math.round(currentCtl * 10) / 10,
      atl: Math.round(currentAtl * 10) / 10,
      tsb: Math.round(tsbToday * 10) / 10,
    });
  }

  return pmcData;
}

export function calculateBikeTSS(
  durationSeconds: number,
  normalizedPower: number,
  ftp: number
): number {
  if (ftp === 0) return 0;
  
  const intensityFactor = normalizedPower / ftp;
  const tss = ((durationSeconds * normalizedPower * intensityFactor) / (ftp * 3600)) * 100;
  
  return Math.round(tss * 10) / 10;
}
